// Define mobile-drawer-component as a custom element
class MobileDrawerComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initializeDrawer();
    }

    initializeDrawer() {
        document.querySelectorAll('div.custom__menu--inner__link').forEach(element => {
            element.addEventListener('click', () => {
                element.classList.toggle('active');
            });
        });

        document.querySelectorAll('.level-1__title-back').forEach(element => {
            element.addEventListener('click', () => {
                element.parentNode.previousElementSibling.classList.remove('active');
            });
        });

        document.querySelectorAll('.level-2__title-trigger').forEach(element => {
            element.addEventListener('click', () => {
                element.classList.toggle('active');
            });
        });

        document.querySelectorAll('.custom__menu-text-level-2-back').forEach(element => {
            element.addEventListener('click', () => {
                element.parentNode.previousElementSibling.classList.remove('active');
            });
        });

        const headerHeight = document.querySelector('#NavDrawer .drawer__header')?.offsetHeight || 0;
        if (headerHeight) {
            document.documentElement.style.setProperty('--navDrawerHeight', headerHeight + 'px');
        }
    }
}

if (!customElements.get('mobile-drawer-component')) {
    customElements.define('mobile-drawer-component', MobileDrawerComponent);
}

document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('mobile-drawer-component')) {
        const drawerComponent = document.createElement('mobile-drawer-component');
        document.body.appendChild(drawerComponent);
    }
});